import { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { FaTimes, FaArrowRight, FaBars } from "react-icons/fa";

import Logotipo from "../img/Logotipo.webp";
import imgNav from "../img/fondo1.webp";
import menu1 from '../img/menu1.webp';
import menu2 from '../img/menu2.webp';
import menu3 from '../img/menu3.webp';
import menu4 from '../img/menu4.webp';
import menu5 from '../img/menu5.webp';
import menu6 from '../img/menu6.webp';
import menu7 from '../img/menu7.webp';
import menu8 from '../img/menu8.webp';
import menu9 from '../img/menu9.webp';
import menu10 from '../img/menu10.webp';
import menu11 from '../img/menu11.webp';
import menu12 from '../img/menu12.webp';

import ModalInicio from "./ModalInicio";
import { PageModal } from "./Utils/CustomStyles";
import SocialFixed from './SocialFixed';

const SCROLL_THRESHOLD = 5; 

const Navbar = () => {
  const [visible, setVisible] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [indiceImagen, setIndiceImagen] = useState(-1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const imagenes = [menu1,menu2,menu3,menu4,menu5,menu6,menu7,menu8,menu9,menu10,menu11,menu12];
  const lastScrollY = useRef(0);

  // Cambiar imagen automática del carrusel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % imagenes.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [imagenes.length]);

  // Mostrar/ocultar navbar al hacer scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY - lastScrollY.current > SCROLL_THRESHOLD) setVisible(false);
      else if (lastScrollY.current - currentScrollY > SCROLL_THRESHOLD) setVisible(true);
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Cerrar modal si cambia de ruta
  useEffect(() => {
    if (modalOpen && location.pathname !== "/") closeModal();
  }, [location.pathname]);

  // Ocultar navbar mientras menú lateral está abierto
  useEffect(() => {
    setVisible(!menuOpen);
  }, [menuOpen]);

  const inicio = () => {
    setMostrarModal(true);
    setTimeout(() => {
      setMostrarModal(false);
      navigate("/");
    }, 1000);
  };

  const openModal = () => {
    sessionStorage.setItem("origenModal", "promos");
    setMenuOpen(false);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    sessionStorage.setItem("modalVisto", "true");
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleClick = (text, idx) => {
    setLoadingIndex(idx);
    setTimeout(() => {
      setLoadingIndex(null);
      if (text === "Promos") openModal();
      else if (text === "Arma tu Roll") {
        setMostrarModal(true);
        setTimeout(() => {
          setMostrarModal(false);
          setMenuOpen(false);
          navigate("/rollperson");
        }, 1000);
      } else {
        setMenuOpen(false);
        navigate("/crear");
      }
    }, 1000);
  };

  const abrirModalImagen = (idx) => setIndiceImagen(idx);
  const cerrarModalImagen = () => setIndiceImagen(-1);
  const imagenSiguiente = () => setIndiceImagen((prev) => (prev + 1) % imagenes.length);
  const imagenAnterior = () => setIndiceImagen((prev) => (prev - 1 + imagenes.length) % imagenes.length);

  return (
    <>
      {/* NAVBAR PRINCIPAL */}
      <motion.nav
        className="fixed top-0 left-0 right-0 z-50 rounded-b-2xl shadow-md shadow-yellow-500 transition-all"
        style={{
          backgroundImage: `url(${imgNav})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        animate={{ opacity: visible ? 1 : 0, y: visible ? 0 : -100 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
      >
        <div className="flex justify-between items-center px-4 h-16">
          {/* LOGO */}
          <button onClick={inicio}>
            <img 
              src={Logotipo} 
              alt="Logotipo" 
              className="h-14 w-14 object-contain" 
              loading="eager" 
              fetchPriority="high"
            />
          </button>

          {/* BOTONES DESKTOP Y MOBILE */}
          <div className="flex space-x-2 sm:space-x-4 items-center">
            <button
              onClick={openModal}
              className="px-3 sm:px-6 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base text-yellow-500 font-semibold rounded-md border-2 border-white shadow-lg hover:bg-white/10 transition-all duration-300"
            >
              Promociones
            </button>
            <button
               onClick={() => abrirModalImagen(0)}
              className="px-3 sm:px-6 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base text-yellow-500 font-semibold rounded-md border-2 border-white shadow-lg hover:bg-white/10 transition-all duration-300"
            >
              Ver Menú
            </button>
          </div>

          {/* BOTÓN MOBILE - Eliminado para mostrar botones directos */}
        </div>
      </motion.nav>

      {/* MENÚ LATERAL MOBILE */}
      <AnimatePresence>
        {menuOpen && (
          <>
            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="fixed inset-0 bg-black/20 backdrop-blur-sm z-30"
              onClick={toggleMenu}
            />

            <motion.div
              initial={{ x: "100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "100%", opacity: 0 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
              style={{
                backgroundImage: `url(${imgNav})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              className="fixed top-0 right-0 h-full w-4/5 shadow-2xl z-40 flex flex-col p-6 rounded-l-2xl"
            >
              {/* HEADER MENU */}
              <div className="flex justify-between items-center mb-6">
                <img 
                  src={Logotipo} 
                  alt="Logotipo" 
                  className="h-16 w-16 object-contain" 
                  loading="eager"
                />
                <button
                  onClick={toggleMenu}
                  aria-label="Cerrar menú"
                  className="bg-neutral-400 py-2 px-2 rounded-xl"
                >
                  <FaTimes className="text-white text-2xl" />
                </button>
              </div>

        {/* BOTONES GRANDES PULSANTES */}
<div className="flex items-center flex-col space-y-4 mb-10">
  {["Promos"].map((text, idx) => (
    <button
      key={idx}
      onClick={() => handleClick(text, idx)}
      className="relative w-40 h-12 rounded-full transition-colors flex items-center justify-center overflow-hidden bg-yellow-500 text-white font-bold"
      style={{ fontFamily: "'Sawarabi Mincho', serif" }}
    >
      {/* Texto */}
      <span className="z-10 pointer-events-none ml-8">{text}</span>

      {/* Círculo animado con icono */}
      <motion.div
        className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-yellow-500 absolute left-0 top-0 m-0"
        animate={{
          x: loadingIndex === idx ? (parseInt("100%")) : 0
        }}
        transition={{ type: "spring", stiffness: 100, damping: 25 }}
      >
        <FaArrowRight />
      </motion.div>
    </button>
  ))}
</div>


              {/* CARRUSEL DE IMÁGENES */}
              <div className="relative w-full overflow-hidden rounded-xl shadow-lg h-90">
                <motion.div
                  animate={{ x: -currentIndex * 100 + "%" }}
                  transition={{ type: "tween", duration: 0.8 }}
                  className="flex w-full h-full"
                >
                  {imagenes.map((img, i) => (
                    <div
                      key={i}
                      className="flex-shrink-0 w-full h-full cursor-pointer rounded-xl overflow-hidden"
                      onClick={() => abrirModalImagen(i)}
                    >
                      <img 
                        src={img} 
                        alt={`Menú ${i}`} 
                        className="w-full h-full object-cover" 
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = Logotipo; // Fallback al logo si falla el menú
                        }}
                      />
                    </div>
                  ))}
                </motion.div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* MODAL DE IMÁGENES */}
      {indiceImagen >= 0 && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50"
          onTouchStart={(e) => setTouchStartX(e.touches[0].clientX)}
          onTouchMove={(e) => setTouchEndX(e.touches[0].clientX)}
          onTouchEnd={() => {
            if (touchStartX !== null && touchEndX !== null) {
              const diff = touchStartX - touchEndX;
              if (diff > 50) imagenSiguiente();
              else if (diff < -50) imagenAnterior();
            }
            setTouchStartX(null);
            setTouchEndX(null);
          }}
        >
          <div className="relative w-full h-full flex items-center justify-center">
            {/* CERRAR */}
            <button
              onClick={cerrarModalImagen}
              className="fixed top-4 right-4 bg-black/30 py-2 px-2 rounded-full text-white z-50"
            >
              <FaTimes />
            </button>

            {/* FLECHAS */}
            <button
              onClick={imagenAnterior}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full z-50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={imagenSiguiente}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full z-50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {/* IMAGEN */}
            <div className="flex items-center justify-center w-full h-full sm:max-w-[90vw] sm:max-h-[90vh]">
              <img
                src={imagenes[indiceImagen]}
                alt={`Menú ampliado ${indiceImagen}`}
                className="object-contain rounded-lg max-w-full max-h-full"
              />
            </div>

            {/* DOTS */}
            <div className="absolute bottom-6 flex gap-2 justify-center z-50 w-full">
              {imagenes.map((_, i) => (
                <span
                  key={i}
                  className={`w-3 h-3 rounded-full transition-all ${i === indiceImagen ? "bg-white" : "bg-gray-500"}`}
                />
              ))}
            </div>
            <SocialFixed />
          </div>
        </div>
      )}

      {/* MODALES */}
      <ModalInicio isOpen={modalOpen} onClose={closeModal} />
      <PageModal mostrarModal={mostrarModal} onComplete={() => setMostrarModal(false)} />
    </>
  );
};

export default Navbar;
